/**
 * What: Provides shared spacing for Shopify embedded app page bodies.
 * Transport / data-flow: Pure React/Polaris layout wrapper used by the app shell.
 *
 */
import type { ReactNode } from 'react'

interface ShopifyPageContentProps {
  children: ReactNode
}

/**
 * Keeps embedded Shopify page bodies from ending flush against the admin frame.
 * `s-box`'s padding scale has no direct equivalent to classic Polaris's numeric
 * space-800 token; `large-200` is the closest visual match for this amount of
 * page-bottom breathing room and isn't pixel-critical.
 */
export function ShopifyPageContent({ children }: ShopifyPageContentProps) {
  return (
    <s-box paddingBlockEnd="large-200" data-testid="shopify-app-page-content">
      {children}
    </s-box>
  )
}
